import { Plan, PlanResponse, Subs, SubsRequest, SubsResponse } from "@/@types";
import { Endpoints, HttpResponse, HttpService } from "@/api";
import { PlanMapper, SubsMapper } from "@/mappers";

export interface SubsServiceInterface {
  listPlans: () => Promise<Plan[]>;
  subscribe: (params: SubsRequest) => Promise<HttpResponse>;
  reactivateSubs: (id: number) => Promise<HttpResponse>;
  manualPaymentSubs: (id: number) => Promise<HttpResponse>;
  cancelSubs: (id: number) => Promise<HttpResponse>;
  showSubs: (id: number) => Promise<Subs>;
  updateSubs: (
    id: number,
    params: Partial<SubsRequest>,
  ) => Promise<HttpResponse>;
}

export class SubscriptionService implements SubsServiceInterface {
  constructor(private readonly http: HttpService) {}

  async listPlans() {
    const { data } = await this.http.get<PlanResponse[]>(Endpoints.plans);

    if (!data) return [];

    return data.map((elem) => PlanMapper.toDomain(elem));
  }

  subscribe = (params: SubsRequest) => {
    return this.http.post<SubsResponse, SubsRequest>(
      Endpoints.subscriptions,
      params,
    );
  };

  reactivateSubs = (id: number) => {
    return this.http.post(`${Endpoints.subscriptions}/${id}/reactivate`, {});
  };

  manualPaymentSubs = (id: number) => {
    return this.http.post(`${Endpoints.subscriptions}/${id}/manual-pay`, {});
  };

  cancelSubs = (id: number) => {
    return this.http.delete(`${Endpoints.subscriptions}/${id}`);
  };

  showSubs = async (id: number) => {
    if (!id) {
      throw new Error("Erro ao buscar assinatura");
    }

    const { data } = await this.http.get<SubsResponse>(
      `${Endpoints.subscriptions}/${id}`,
    );

    if (!data) {
      throw new Error("Erro ao buscar assinatura");
    }
    return SubsMapper.toDomain(data);
  };

  updateSubs = (id: number, params: Partial<SubsRequest>) => {
    return this.http.put(`${Endpoints.subscriptions}/${id}`, params);
  };
}
